import type { TargetOption } from '../../../models/Targeting';

export type CampaignBuilderAnalyticsContext = {
  campaignId?: string;
  lineItemId?: string;
  adAccountId?: string;
  lineItemStatus?: string | null;
  politicalClassification?: string;
  industryVertical?: string;
  userRole?: string;
  isValidatedEdit?: boolean;
  contentTargetingCatalog?: TargetOption[];
};

let campaignBuilderAnalyticsContext: CampaignBuilderAnalyticsContext = {};

export const setCampaignBuilderAnalyticsContext = (context: CampaignBuilderAnalyticsContext): void => {
  campaignBuilderAnalyticsContext = { ...campaignBuilderAnalyticsContext, ...context };
};

export const clearCampaignBuilderAnalyticsContext = (): void => {
  campaignBuilderAnalyticsContext = {};
};

export const getCampaignBuilderAnalyticsContext = (): CampaignBuilderAnalyticsContext =>
  campaignBuilderAnalyticsContext;
